import React, { useContext, useEffect, useState } from 'react';
import { Box, CardHeader, Chip, Divider, makeStyles } from '@material-ui/core';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import { AvatarGroup, Skeleton } from '@material-ui/lab';
import Linkify from 'react-linkify';
import { useHistory } from 'react-router-dom';
import { blue } from '@material-ui/core/colors';
import { SecureLink } from 'react-secure-link';
import { MeetingsContext } from '../../../../services/meetings/meetings.context';

const useStyles = makeStyles((theme) => {
  return {
    cardAvatar: {
      marginRight: 16,
    },
    cardBtn: {
      textTransform: 'lowercase',
    },
    memberList: {
      width: theme.spacing(3),
      height: theme.spacing(3),
    },
    cardHeaderRoot: {
      overflow: 'hidden',
    },
    cardHeaderContent: {
      overflow: 'hidden',
    },
    submitBox: {
      display: 'flex',
      alignItems: 'center',
    },
    wrapper: {
      margin: '10px 0',
      position: 'relative',
    },
    buttonProgress: {
      color: '#000',
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    acceptBtn: {
      marginRight: 6,
    },
    guest: {
      color: blue[900],
    },
    cardMedia: {
      width: '100%',
      height: 'auto',
      display: 'block',
    },
  };
});

export const MemoriesCard = ({ meeting, user }) => {
  const classes = useStyles();
  const history = useHistory();
  const [status, setStatus] = useState('');
  const [meetingHost, setMeetingHost] = useState('');
  const [meetingUsers, setMeetingUsers] = useState([]);

  const { getUsersData } = useContext(MeetingsContext);

  const addNoneMembers = (meeting) => {
    const non_member = meeting.members
      .filter((item) => item.member_uuid === null)
      .map((i) => i);

    if (non_member) {
      non_member.map((i) =>
        setMeetingUsers([
          ...meetingUsers,
          {
            email: i.email,
            uid: null,
          },
        ])
      );
    } else {
      setMeetingUsers([...meetingUsers]);
    }
  };

  useEffect(() => {
    const host =
      meeting &&
      meeting.members &&
      user &&
      meeting.members.filter(
        (item) => item.member_uuid && item.member_uuid === user.uid
      );

    if (host && host.length > 0) {
      setStatus(host[0].status);
    }

    meeting && getUsersData(meeting, setMeetingHost, setMeetingUsers);

    meeting && addNoneMembers(meeting);
  }, [meeting, user]);

  const Meeting_status = () => {
    switch (status) {
      case 0:
        return <Chip label='You are host' size='small' />;
      case 1:
        return (
          <Chip
            color='secondary'
            label='You have joined this meeting'
            size='small'
          />
        );
      case 2:
        return (
          <Chip
            color='primary'
            label='You have rejected this meeting'
            size='small'
          />
        );
      case 3:
        return (
          <Chip
            className={classes.guest}
            label='you were invited'
            size='small'
          />
        );
      case 4:
        return (
          <Chip
            className={classes.guest}
            label='you were invited'
            size='small'
          />
        );
      case 5:
        return (
          <Chip
            color='secondary'
            label='The host has accepted the join request'
            size='small'
          />
        );
      case 6:
        return (
          <Chip
            color='primary'
            label='The host has declined the join request'
            size='small'
          />
        );
      default:
        return null;
    }
  };

  return (
    <Card elevation={2}>
      <CardHeader
        classes={{
          root: classes.cardHeaderRoot,
          content: classes.cardHeaderContent,
        }}
        title={
          <Typography noWrap gutterBottom variant='subtitle2'>
            {meeting.title}
          </Typography>
        }
        avatar={
          <Avatar className={classes.cardAvatar} src={meetingHost.avatar}>
            {meetingHost &&
              meetingHost.username &&
              meetingHost.username.charAt(0).toUpperCase()}
          </Avatar>
        }
      />

      <Box>
        <Box boxShadow={1}>
          {meeting && meeting.meetingphoto && meeting.meetingphoto.image ? (
            <CardMedia
              component='img'
              className={classes.cardMedia}
              image={meeting.meetingphoto.image}
            />
          ) : (
            <Box display='flex'>
              <Skeleton animation='wave' height={200} width='100%' />
            </Box>
          )}
        </Box>
        <CardContent className='description' dir='auto'>
          <Linkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
              <SecureLink href={decoratedHref} key={key}>
                {decoratedText}
              </SecureLink>
            )}
          >
            <Typography noWrap>{meeting.description}</Typography>
          </Linkify>
        </CardContent>
        <Box display='flex' justifyContent='center' mb={2}>
          <Box>{Meeting_status}</Box>
        </Box>
      </Box>
      <Divider variant='middle' />
      <CardActions position='static'>
        <Box display='flex' flexGrow={1}>
          <Button
            size='small'
            className={classes.cardBtn}
            color='primary'
            onClick={() =>
              history.push({
                pathname: `/meetings-details/${meeting.id}`,
                state: { meeting },
              })
            }
          >
            see more info
          </Button>
        </Box>
        <AvatarGroup max={3}>
          {meetingUsers &&
            meetingUsers.map((user) => (
              <Avatar
                title={user.name}
                alt={user.name}
                src={user.avatar}
                key={user.user_uuid}
              >
                {user.username
                  ? user.username[0].toUpperCase()
                  : user.email && user.email[0].toUpperCase()}
              </Avatar>
            ))}
        </AvatarGroup>
      </CardActions>
    </Card>
  );
};
